import { render } from "./UnturnedPath.vue?vue&type=template&id=27c00ea0&scoped=true"
import script from "./UnturnedPath.vue?vue&type=script&lang=js"
export * from "./UnturnedPath.vue?vue&type=script&lang=js"

import "./UnturnedPath.vue?vue&type=style&index=0&id=27c00ea0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27c00ea0"]])

export default __exports__